import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";
import "hamburgers/dist/hamburgers.css";
import { MobileWidth, Wrapper } from "../../GlobalStyle";
import useNavHeader from "../useNavHeader";
import { HeaderWrapper } from "./Styled";

const NAV_LIST = [
  {
    title: "home",
  },
  {
    title: "about",
  },
  {
    title: "services",
  },
  {
    title: "faqs",
  },
  {
    title: "education",
  },
  {
    title: "clients",
  },
  {
    title: "teams",
  },
];

function Header() {
  const { isHeaderShown } = useNavHeader();
  const isMobile = useMediaQuery({ query: `(max-width: ${MobileWidth})` });
  const [active, setActive] = useState(NAV_LIST[0].title);
  const [showNav, setShowNav] = useState(false);

  return (
    <HeaderWrapper className={!isHeaderShown && !isMobile ? "top" : ""}>
      <Wrapper>
        <div className="logo-wrapper">
          <img src={require(`../../images/logo.png`)} alt="Seedverse" />
        </div>

        <nav className={`nav ${showNav ? "active" : ""}`}>
          {NAV_LIST.map((nav) => {
            const { title } = nav;
            return (
              <a
                key={`header-${title}`}
                href={`#${title}`}
                className={`nav-item ${active === title ? "active" : ""}`}
                onClick={() => {
                  setActive(title);
                  setShowNav(false);
                }}
              >
                {title}
              </a>
            );
          })}
        </nav>

        <button
          className={`hamburger hamburger--elastic ${
            showNav ? "is-active" : ""
          }`}
          type="button"
          onClick={() => setShowNav(!showNav)}
        >
          <span className="hamburger-box">
            <span className="hamburger-inner" />
          </span>
        </button>
      </Wrapper>
    </HeaderWrapper>
  );
}

export default Header;
